(function ($) {
	var methods = {
		init: function () {
			return this.each(function () {
				var $this = $(this);
//				if($this.attr("readonly")){
//					return;
//				}
				var data = $this.data('inputDate');
				var mask = "ДД.ММ.ГГГГ";
				var checkDate = function (dateString) {
					var pattern = new RegExp(/^(0[1-9]|[12][0-9]|3[01])\.(0[1-9]|1[012])\.(((19|20|21)[0-9]{2})|(2100))$/);
					var dateMatch = dateString.match(pattern);
					if (dateMatch === null) {
						return false;
					}
					try {
						var day = parseInt(dateMatch[1]);
						var month = parseInt(dateMatch[2]) - 1;
						var year = parseInt(dateMatch[3]);
						var sourceDate = new Date(year, month, day);
						if (sourceDate.getFullYear() !== year || sourceDate.getMonth() !== month || sourceDate.getDate() !== day) {
							return false;
						}
					} catch (e) {
						return false;
					}
					return true;
				};
				var onPaste = (event) => {
					if ($this.attr("readonly")) {
						return;
					}
					event = event.originalEvent || event;
					var clipboardData = event.clipboardData || window.clipboardData;
					var pastedData = clipboardData.getData('Text');
					event.stopPropagation();
					event.stopImmediatePropagation();
					event.preventDefault();
					var raw = pastedData.replace(/[^0-9]/g, '');
					var rawArr = raw.split('');
					var start = event.target.selectionStart;
					for (var i = 0; i < rawArr.length; i++) {
						if (i === 2 || i === 4) {
							start++;
						}
						setChar(event.target, rawArr[i], start + i, start + i + 1);
					}
					return false;
				};
				//$this.checkDate = $this.bind(checkDate);

				var setChar = (target, char, start, end) => {
					if ($this.attr("readonly")) {
						return;
					}
					if (start <= 2) {
						//Ввод даты
						$(target).data("inputDate").inputItems.mm = 0;
						$(target).data("inputDate").inputItems.yyyy = 0;
						$(target).data("inputDate").inputItems.dd++;
						if (target.value.substring(0, 2) === "ДД" || $(target).data("inputDate").inputItems.dd === 1) {
							target.value = "__" + target.value.substring(2, target.value.length);
							target.selectionStart = 0;
							target.selectionEnd = 2;
						}
						if ($(target).data("inputDate").inputItems.dd === 1) {
							//Ввод первого символа даты
							if (parseInt(char) > 3) {
								target.value = 0 + char + target.value.substring(2, target.value.length);
								target.selectionStart = 3;
								target.selectionEnd = 5;
								$(target).data("inputDate").inputItems.dd = 0;
							} else {
								target.value = char + target.value.substring(1, target.value.length);
								target.selectionStart = 0;
								target.selectionEnd = 2;
							}
						} else {
							if (parseInt(target.value.substring(0, 1)) === 3 && parseInt(char) > 1) {
								target.value = 0 + target.value.substring(0, 1) + target.value.substring(2, target.value.length);
								target.selectionStart = 3;
								target.selectionEnd = 5;
								setChar(target, char, 3, 5);
								$(target).data("inputDate").inputItems.dd = 0;
							} else {
								target.value = target.value.substring(0, 1) + char + target.value.substring(2, target.value.length);
								checkDD(target);
								target.selectionStart = 3;
								target.selectionEnd = 5;
								$(target).data("inputDate").inputItems.dd = 0;
							}
						}
					} else if (start >= 3 && start <= 5) {
						//Ввод месяца
						$(target).data("inputDate").inputItems.mm++;
						$(target).data("inputDate").inputItems.yyyy = 0;
						$(target).data("inputDate").inputItems.dd = 0;

						if (target.value.substring(3, 5) === "ММ" || $(target).data("inputDate").inputItems.mm === 1) {
							target.value = target.value.substring(0, 3) + "__" + target.value.substring(5, target.value.length);
							target.selectionStart = 3;
							target.selectionEnd = 5;
						}

						if ($(target).data("inputDate").inputItems.mm === 1) {
							if (parseInt(char) > 1) {
								target.value = target.value.substring(0, 3) + 0 + char + target.value.substring(5, target.value.length);
								target.selectionStart = 6;
								target.selectionEnd = 10;
								$(target).data("inputDate").inputItems.mm = 0;
							} else {
								target.value = target.value.substring(0, 3) + char + target.value.substring(4, target.value.length);
								target.selectionStart = 3;
								target.selectionEnd = 5;
							}
						} else {
							if (parseInt(target.value.substring(3, 4)) === 1 && parseInt(char) > 2) {
								checkMM(target);
								target.selectionStart = 6;
								target.selectionEnd = 10;
								$(target).data("inputDate").inputItems.mm = 0;
								setChar(target, char, 6, 10);
							} else if (parseInt(target.value.substring(3, 4)) === 0 && parseInt(char) === 0) {
								target.selectionStart = 3;
								target.selectionEnd = 5;
								$(target).data("inputDate").inputItems.mm = 1;
							} else {
								target.value = target.value.substring(0, 4) + char + target.value.substring(5, target.value.length);
								checkMM(target);
								target.selectionStart = 6;
								target.selectionEnd = 10;
								$(target).data("inputDate").inputItems.mm = 0;
							}

						}
					} else if (start >= 6 && start <= 10) {
						//Ввод года
						$(target).data("inputDate").inputItems.mm = 0;
						$(target).data("inputDate").inputItems.yyyy++;
						$(target).data("inputDate").inputItems.dd = 0;
						if (target.value.substring(6, 10) === "ГГГГ" || $(target).data("inputDate").inputItems.yyyy === 1) {
							target.value = target.value.substring(0, 6) + "0___";
							target.selectionStart = 6;
							target.selectionEnd = 10;
						}
						if ($(target).data("inputDate").inputItems.yyyy === 1) {
							if (parseInt(char) < 1 || parseInt(char) > 2) {
								$(target).data("inputDate").inputItems.yyyy = 3;
								target.value = target.value.substring(0, 6) + 20 + char + target.value.substring(9, target.value.length);
							} else {
								target.value = target.value.substring(0, 6) + char + target.value.substring(7, target.value.length);
							}
							target.selectionStart = 6;
							target.selectionEnd = 10;
						} else if ($(target).data("inputDate").inputItems.yyyy === 2) {
							if (parseInt(target.value.substring(6, 7)) === 1 && parseInt(char) !== 9) {
								target.value = target.value.substring(0, 6) + 201 + char;
								target.selectionStart = 6;
								target.selectionEnd = 10;
								$(target).data("inputDate").inputItems.yyyy = 0;
							} else if (parseInt(target.value.substring(6, 7)) === 2 && parseInt(char) > 1) {
								target.value = target.value.substring(0, 6) + 202 + char;
								target.selectionStart = 6;
								target.selectionEnd = 10;
								$(target).data("inputDate").inputItems.yyyy = 0;
							} else {
								target.value = target.value.substring(0, 7) + char + target.value.substring(8, target.value.length);
								target.selectionStart = 6;
								target.selectionEnd = 10;
							}
						} else if ($(target).data("inputDate").inputItems.yyyy === 3) {
							target.value = target.value.substring(0, 8) + char + target.value.substring(9, target.value.length);
							target.selectionStart = 6;
							target.selectionEnd = 10;
						} else if ($(target).data("inputDate").inputItems.yyyy === 4) {
							target.value = target.value.substring(0, 9) + char;
							target.selectionStart = 6;
							target.selectionEnd = 10;
							$(target).data("inputDate").inputItems.yyyy = 0;
						}
					}
				};
				var checkDD = (target) => {
					if ($this.attr("readonly")) {
						return;
					}
					if (target.value.substring(1, 2) === "_") {
						target.value = "0" + target.value.substring(0, 1) + target.value.substring(2, target.value.length);
					}
					if (target.value.substring(0, 2) === "00") {
						target.value = "01" + target.value.substring(2, target.value.length);
					}
				};
				var checkMM = (target) => {
					if ($this.attr("readonly")) {
						return;
					}
					if (target.value.substring(4, 5) === "_") {
						target.value = target.value.substring(0, 3) + "0" + target.value.substring(3, 4) + target.value.substring(5, target.value.length);
					}
					if (target.value.substring(3, 5) === "00") {
						target.value = target.value.substring(0, 3) + "01" + target.value.substring(5, target.value.length);
					}
				};

				if (!data) {
					if ($this.val().length > 0) {
						var validDate = checkDate($this.val());
						$this.toggleClass("invalid", !validDate);
//						$this.setCustomValidity((checkDate ? "" : "Введите данные в указанном формате!"));
					}
					if (!$this.attr("placeholder")) {
						$this.attr({"placeholder": mask});
					}
					$this.data('inputDate', {
						target: $this,
						inputItems: {
							dd: 0,
							mm: 0,
							yyyy: 0
						}
					});
					$this.on('keydown.inputDate', function (event) {
						if ($this.attr("readonly")) {
							return;
						}
						event = event.originalEvent || event;

						var target = event.target;
						var keyCode = event.keyCode;

						if (keyCode === 9) {
							// (Tab)
							return true;
						}

						event.stopPropagation();
						event.stopImmediatePropagation();


						if (keyCode === 8) {
							//Стирание (Backspace)
							var start = target.selectionStart;
							var end = target.selectionEnd;
							target.value = target.value.substring(0, target.selectionStart) + mask.substring(target.selectionStart, target.selectionEnd) + target.value.substring(target.selectionEnd, target.value.length);
							target.selectionStart = start;
							target.selectionEnd = end;
							return false;
						}
						if (keyCode === 13) {
							// (Enter)
							return true;
						}
						if (keyCode === 46) {
							// (Delete)
							var start = target.selectionStart;
							var end = target.selectionEnd;
							target.value = target.value.substring(0, target.selectionStart) + mask.substring(target.selectionStart, target.selectionEnd) + target.value.substring(target.selectionEnd, target.value.length);
							target.selectionStart = start;
							target.selectionEnd = end;
							return false;
						}
						if (keyCode === 86 && event.ctrlKey) {
							//Вставка (Ctrl+v)
							return true;
						}
						if (keyCode === 67 && event.ctrlKey) {
							//Копирование (Ctrl+c)
							return true;
						}
						if (keyCode === 65 && event.ctrlKey) {
							//Выделение (Ctrl+a)
							return true;
						}
						if (keyCode === 37) {
							//Влево
							if (target.selectionStart >= 0 && target.selectionStart <= 3) {
								checkMM(target);
								target.selectionStart = 0;
								target.selectionEnd = 2;
							} else if (target.selectionStart > 3) {
								target.selectionStart = 3;
								target.selectionEnd = 5;
							}
							$this.data('inputDate').inputItems = {
								dd: 0,
								mm: 0,
								yyyy: 0
							};
							return false;
						}
						if (keyCode === 39) {
							//Впваво
							if (target.selectionEnd < 3) {
								checkDD(target);
								target.selectionStart = 3;
								target.selectionEnd = 5;
							} else {
								checkMM(target);
								target.selectionStart = 6;
								target.selectionEnd = 10;
							}
							$this.data('inputDate').inputItems = {
								dd: 0,
								mm: 0,
								yyyy: 0
							};
							return false;
						}

						var isAllowedChar = false;

						if ((keyCode >= 48 && keyCode <= 57) || (keyCode >= 96 && keyCode <= 105)) {
							//Цифры
							isAllowedChar = true;
						}
						if ((keyCode >= 110 && keyCode <= 111) || (keyCode >= 190 && keyCode <= 191)) {
							//Разделитель (./)
							if (target.selectionEnd < 3) {
								checkDD(target);
								target.selectionStart = 3;
								target.selectionEnd = 5;
							} else {
								checkMM(target);
								target.selectionStart = 6;
								target.selectionEnd = 10;
							}
							$this.data('inputDate').inputItems = {
								dd: 0,
								mm: 0,
								yyyy: 0
							};
							return false;
						}
						if (!isAllowedChar) {
							event.preventDefault();
							console.log(event.keyCode);
							return false;
						}
						setChar(target, event.key, target.selectionStart, target.selectionEnd);
						return false;
					});

					$this.on("change.inputDate", function (event) {
						if ($this.attr("readonly")) {
							return;
						}
						var target = event.target;
						var value = target.value;
						var validDate = value.length > 0 && checkDate(value);
						target.classList.toggle("invalid", !validDate);
						target.setCustomValidity((validDate ? "" : "Введите данные в указанном формате!"));
					});
					$this.on("focusout.inputDate", function (event) {
						if ($this.attr("readonly")) {
							return;
						}
						var target = event.target;
						var value = target.value;
						if (value === mask) {
							value = "";
						} else if (value.substring(8, 10) === "__") {
							if (value.substring(7, 8) === "_") {
								value = value.substring(0, 6) + 0 + value.substring(6, 7) + value.substring(8, 10);
							}
							value = value.substring(0, 6) + 20 + value.substring(6, 8);
						}
						target.value = value;
						var validDate = !((value.length > 0 && !checkDate(value)) || (value.length === 0 && target.attributes.required !== void 0));

						target.classList.toggle("invalid", !validDate);
						target.setCustomValidity((validDate ? "" : "Введите данные в указанном формате!"));
						$this.data('inputDate').inputItems = {
							dd: 0,
							mm: 0,
							yyyy: 0
						};
					});
					$this.on("focus.inputDate", function (event) {
						if ($this.attr("readonly")) {
							return;
						}
						event = event.originalEvent || event;
						var target = event.target;
						var value = target.value;
						if (value.length === 0) {
							target.value = mask;
						}
					});
					$this.on("click.inputDate", function (event) {
						if ($this.attr("readonly")) {
							return;
						}
						event = event.originalEvent || event;
						var target = event.target;
						var s = target.selectionStart;
						if (target.value === mask) {
							target.selectionStart = 0;
							target.selectionEnd = 10;
						} else if (s >= 0 && s <= 2) {
							target.selectionStart = 0;
							target.selectionEnd = 2;
						} else if (s >= 3 && s <= 5) {
							target.selectionStart = 3;
							target.selectionEnd = 5;
						} else if (s >= 6 && s <= 10) {
							target.selectionStart = 6;
							target.selectionEnd = 10;
						}
						$this.data('inputDate').inputItems = {
							dd: 0,
							mm: 0,
							yyyy: 0
						};
					});
					$this.on("drop.inputDate", function (event) {
						if ($this.attr("readonly")) {
							return;
						}
						event = event.originalEvent || event;
						event.preventDefault();
						event.stopPropagation();
						event.stopImmediatePropagation();
						return false;
					});
					$this.on("paste.inputDate", onPaste);
				}
			});
		},
		destroy: function () {
			return this.each(function () {
				var $this = $(this);
				$this.removeData('inputDate');
				$(window).unbind('.inputDate');
			});

		}
	};
	$.fn.inputDate = function (method) {
		if (methods[method]) {
			return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
		} else if (typeof method === 'object' || !method) {
			return methods.init.apply(this, arguments);
		} else {
			$.error('Метод с именем ' + method + ' не существует для jQuery.inputDate');
		}
	};
})(jQuery);


